var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"line",attrs:{"height":"5","width":"400"}},[_c('polyline',{attrs:{"points":"0,0 400,2.5 0,5"}})])}
var staticRenderFns = []

export { render, staticRenderFns }